import { useState } from "react";
import { audioExt } from "../lib/media";
import { Search, X, Loader2, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { Recorder } from "./Recorder";
import { API, authHeaders } from "../lib/supabase";
import { filterChips, removeChip } from "../lib/jobFilters";
import { useOnline } from "../lib/net";

export const SearchBar = ({ filters, onFilters, onSpoken }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const online = useOnline();
  const chips = filterChips(filters);

  const run = async (fd) => {
    setBusy(true);
    try {
      fd.append("today", new Date().toLocaleDateString("en-CA"));
      fd.append("language", navigator.language || "en");
      const r = await fetch(`${API}/ai/search`, { method: "POST", headers: await authHeaders(), body: fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Search failed");
      if (!Object.keys(d.filters).length) { toast.message("Couldn't work out a filter", { description: d.transcript }); onFilters({ text: d.transcript }); }
      else onFilters(d.filters);
      setText(d.transcript || "");
      onSpoken?.(d.spoken_summary, d.filters);
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };

  const submitText = (e) => {
    e.preventDefault();
    if (!text.trim()) return onFilters(null);
    if (!online) return onFilters({ text: text.trim() });
    const fd = new FormData(); fd.append("text", text.trim()); run(fd);
  };
  const onAudio = (blob) => { if (!online) return toast.error("Voice search needs a connection — type instead"); const fd = new FormData(); fd.append("audio", blob, `search.${audioExt(blob)}`); run(fd); };

  return (
    <div className="mb-4" data-testid="search-bar">
      <form onSubmit={submitText} className="search-row">
        <Search size={16} className="text-muted shrink-0" />
        <input className="search-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Search or ask: “jobs from last week that aren't done”" data-testid="search-input" />
        {busy ? <Loader2 size={18} className="animate-spin text-primary shrink-0" data-testid="search-busy" /> : <Recorder compact onAudio={onAudio} disabled={busy} />}
      </form>
      {(chips.length > 0) && (
        <div className="flex gap-2 flex-wrap mt-3" data-testid="active-filters">
          {chips.map((c) => (
            <span key={c.key} className="chip chip-blue" data-testid={`filter-chip-${c.key}`}>{c.label}<button type="button" className="ml-1" onClick={() => onFilters(removeChip(filters, c.key))} aria-label={`Remove ${c.label}`} data-testid={`filter-chip-remove-${c.key}`}><X size={12} /></button></span>
          ))}
          <button type="button" className="chip" onClick={() => { onFilters(null); setText(""); }} data-testid="filters-clear">Clear</button>
          {onSpoken && <span className="text-xs text-muted flex items-center gap-1 self-center" data-testid="search-readback-hint"><Volume2 size={12} /> readback</span>}
        </div>
      )}
    </div>
  );
};
